(() => {
  const getSelectedOptions = (picker) => {
    if (picker.tagName.toLowerCase() === 'variant-radios') {
      return [...picker.querySelectorAll('fieldset')].map(
        (fieldset) => fieldset.querySelector('input:checked')?.value
      );
    }

    return [...picker.querySelectorAll('select')].map((select) => select.value);
  };

  const setVariantPrice = (picker) => {
    const sectionId = picker.dataset.section;
    const sourceSectionId = picker.dataset.originalSection || sectionId;
    const dataElement =
      document.getElementById(`NoisycodeVariantPrices-${sectionId}`) ||
      document.getElementById(`NoisycodeVariantPrices-${sourceSectionId}`);

    if (!dataElement) return;

    let variants;
    try {
      variants = JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('Unable to read variant price data.', error);
      return;
    }

    const selectedOptions = getSelectedOptions(picker);
    if (selectedOptions.some((option) => option === undefined)) return;

    const variant = variants.find(
      (item) =>
        item.options.length === selectedOptions.length &&
        item.options.every((option, index) => option === selectedOptions[index])
    );
    if (!variant) return;

    const priceDestination = document.getElementById(`price-${sectionId}`);
    const priceRoot = priceDestination?.querySelector('.price');
    if (!priceRoot) return;

    const regularPrice = priceRoot.querySelector('.price__regular .price-item--regular');
    const saleComparePrice = priceRoot.querySelector('.price__sale .price-item--regular');
    const salePrice = priceRoot.querySelector('.price__sale .price-item--sale');
    const onSale = Boolean(variant.compareAtPrice);

    if (regularPrice) regularPrice.textContent = variant.price;
    if (salePrice) salePrice.textContent = variant.price;
    if (saleComparePrice && variant.compareAtPrice) saleComparePrice.textContent = variant.compareAtPrice;

    priceRoot.classList.toggle('price--on-sale', onSale);
    priceRoot.classList.toggle('price--sold-out', !variant.available);
    priceDestination.classList.remove('hidden');

    const skuDestination = document.getElementById(`Sku-${sectionId}`);
    const skuValue = skuDestination?.querySelector('[data-nc-sku-value]');
    if (skuValue) skuValue.textContent = variant.sku || '';
  };

  const initializePicker = (picker) => {
    if (picker.dataset.noisycodeVariantPriceReady === 'true') return;
    picker.dataset.noisycodeVariantPriceReady = 'true';

    picker.addEventListener('change', () => {
      // Dawn replaces the full price block after fetching the selected variant.
      // This immediate update removes the visual delay and also serves as a fallback.
      requestAnimationFrame(() => setVariantPrice(picker));
    });
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('variant-radios, variant-selects').forEach(initializePicker);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
